var _g, _rect, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66_3687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 38V10C8 6.686 10.686 4 14 4H26.7574C27.553 4 28.3161 4.31607 28.8787 4.87868L39.1213 15.1213C39.6839 15.6839 40 16.447 40 17.2426V38C40 41.314 37.314 44 34 44H14C10.686 44 8 41.314 8 38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 38V10C8.5 6.96214 10.9621 4.5 14 4.5H26.7574C27.4204 4.5 28.0563 4.76339 28.5251 5.23223L38.7678 15.4749C39.2366 15.9437 39.5 16.5796 39.5 17.2426V38C39.5 41.0379 37.0379 43.5 34 43.5H14C10.9621 43.5 8.5 41.0379 8.5 38Z",
    stroke: "#DBDBDB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 23,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#6C6C6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#6C6C6C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#6C6C6C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#DBDBDB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66_3687",
    x: 7,
    y: 4,
    width: 34,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_3687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66_3687",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.26a5c7f268e759c9dd2be21c2aaadf34.svg";
export { ForwardRef as ReactComponent };